import AutoNumeric from 'autonumeric';

export const autoNumericFormatter = () => {
  AutoNumeric.multiple('.format_number', {
    alwaysAllowDecimalCharacter: false,
    decimalPlaces: 0,
    digitGroupSeparator: ' ',
  });
};

